import { useState } from 'react';
import QuestionCanvas from "./QuestionCanvas";
import { Box, Tab, Tabs, Paper, Typography } from '@mui/material';
import { config } from '../../Const';
import { executeFetchAsync } from '../../Util';
import AIQuestionBank from './AIQuestionBank';
import DataQuestionBank from './DataQuestionBank';



function MCQuestionEditor({ entity, quizSubject, aiQuestionsSubjectText, questionData, onDeleteQuestion, onChangeQuestion, onUpDownQuestion, onAddQuestion, onCreateNewQuestion }) {

    const notifyCreateNewQuestion = async () => {
        const formData = new FormData();
        formData.append('questionParamsJson', '{}');

        const url = config.SERVER_URL + "/api/v1/admin/generateMCQuestions/GeneralMCQuestion/edit";

        try {
            const newQuestion = await executeFetchAsync(url, "post", null, formData);

            newQuestion.question.templateId = newQuestion.question.templateId.split("~~~")[0] + "~~~" + Math.random();

            let clonedQuestionData = JSON.parse(JSON.stringify(questionData));
            clonedQuestionData.unshift(newQuestion);

            onCreateNewQuestion(clonedQuestionData);
        } catch (error) {
            console.error("Failed to create new question:", error);
        }
    };


    const [tabIndex, setTabIndex] = useState(0);

    const handleTabChange = (event, newTabIndex) => {
        setTabIndex(newTabIndex);
    };

    return (
        <Box sx={{ height: '100%' }}>

            <Box sx={{ display: 'flex', gap: '200px', align: 'flexStart' }}>
                <Typography variant="h6">Questions</Typography>

            </Box>

            <Box sx={{ height: 3 }}></Box>

            <Paper elevation={10} sx={{ height: '92%', overflowY: 'hidden', pl: '30px', pb: '20px', pr: '20px', pt: '10px' }}>
                <Tabs value={tabIndex} onChange={handleTabChange} aria-label="basic tabs example">
                    <Tab label="Data Generated" index={0} ></Tab>
                    <Tab label="AI Generated" index={1} ></Tab>
                    <Tab label="Selected" index={2} />

                </Tabs>

                <Box sx={{
                    height: '20px'
                }}></Box>


                <Box sx={{ height: '90%', display: (tabIndex === 0 ? 'block' : 'none') }}>

                    <DataQuestionBank entity={entity} quizSubject={quizSubject} onAddQuestion={onAddQuestion}></DataQuestionBank>
                </Box>

                <Box sx={{ height: '90%', display: (tabIndex === 1 ? 'block' : 'none') }}>

                    <AIQuestionBank aiQuestionsSubjectText={aiQuestionsSubjectText} onAddQuestion={onAddQuestion}></AIQuestionBank>
                </Box>

                <Box sx={{ height: '90%', display: (tabIndex === 2 ? 'block' : 'none') }}>

                    <QuestionCanvas questionData={questionData} onCreateNewQuestion={notifyCreateNewQuestion} onDeleteQuestion={onDeleteQuestion} onChangeQuestion={onChangeQuestion} onUpDownQuestion={onUpDownQuestion}></QuestionCanvas>


                </Box>
            </Paper>

        </Box >
    )

};

export default MCQuestionEditor;
